import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom";
import { Grid } from "@mui/material";

import { DB, Constant } from "../../constants";
import NavigationBar from "../NavigationBar";
import "./style.css";
import { useTranslation } from 'react-i18next';

const SavedFormPage = () => {
    const { t: translate } = useTranslation();
    const { state } = useLocation()
    const [savedForm, setSavedForm] = useState([])

    const getSavedForm = async () => {
        const saveFormDataQuery = await DB.saveFormData.toArray();
        const saveFormDatasByUserId = saveFormDataQuery.filter((form) => form.userId === parseInt(localStorage.getItem(Constant.localStorageKey.userId)));
        setSavedForm(saveFormDatasByUserId)
    }

    useEffect(() => {
        getSavedForm()
    }, [])

    return <div className={`page ${state && state.prev ? "page--prev" : ""}`}>
        <NavigationBar showToolBar={false} showNavBar={true} />
        <div className="form-group">
            <h1>RAPPORTS EN ATTENTE</h1>
            <Grid container spacing={2}>
                {savedForm.length > 0 ? savedForm.map((form, index) => {
                    return <Grid item key={index} xs={12} md={6} xl={4}>
                        <div key={index} className="saved-form-list-item">
                            <p>{form.date.split("-").join("/")}</p>
                            <p>/</p>
                            <p>{form.data["materiel-numserie"]}</p>
                            <p>/</p>
                            <p>{form.data["materiel-immat"]}</p>
                        </div>
                    </Grid>
                }) : <Grid item xs={12} md={12} xl={12}>
                    <p className="empty-list-text">{translate('reportSynchronized')}</p>
                </Grid>}
            </Grid>
        </div>
        <div className="saved-form-container">

        </div>
    </div>
}

export default SavedFormPage;